import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/other/Loader";
import HeroSection from "../../../../layout/HeroSection";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonThinkercad } from "../../../../redux/action/lessonsAction";
import SecureContent from "../../../../components/secureContent";
const Tinkercad = () => {
  const dispatch = useDispatch();
  const { thinkercadList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonThinkercad());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Tinkercad"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            // {
            //   name: "3D modeling",
            //   path: pageRoutes?.lessons?.threeDModling,
            // },
            { name: "Tinkercad", path: `${pageRoutes?.home}/` },
          ]}
        />

        <Listing contentData={thinkercadList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default Tinkercad;
